import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialMediumIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M7.43283 6.04999C10.6967 6.04999 13.3423 8.71408 13.3423 12.0001C13.3423 15.2861 10.6965 17.95 7.43283 17.95C4.16936 17.95 1.52335 15.2861 1.52335 12.0001C1.52335 8.71417 4.16911 6.04999 7.43283 6.04999ZM16.87 6.3985C18.5019 6.3985 19.8248 8.90618 19.8248 12.0001H19.8251C19.8251 15.0932 18.5022 17.6016 16.8703 17.6016C15.2385 17.6016 13.9155 15.0932 13.9155 12.0001C13.9155 8.907 15.2382 6.3985 16.8701 6.3985H16.87ZM21.4374 6.982C22.0113 6.982 22.4767 9.22867 22.4767 12.0002C22.4767 14.7707 22.0114 17.0183 21.4374 17.0183C20.8634 17.0183 20.3984 14.7714 20.3984 12.0002C20.3984 9.22883 20.8637 6.982 21.4374 6.982Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
